import { useEffect, useRef, useState } from 'react';
import {
  Box, 
  Text, 
  Spinner,
  HStack,
  useToast
} from '@chakra-ui/react';
import { deleteData, getData } from '../services/storage';
import { organizationSignUp, storeOrgDataToStorage } from '../services/organization';
import { useNavigate } from 'react-router-dom';
import { OrganizationSubscription } from '../utils/types';
import { saveOrganizationSubscription } from '../hooks/subscription';

type Step = 'signup' | 'login' | 'enterToken' | 'done';

export interface OrgData {
  name: string;
  description: string;
  industry: string;
  website: string;
  email: string;
  phone_number: string;
  address: string;
  is_active: boolean;
  owner: string;
}

export default function OrganizationCreateProcessPage() {
  const [loading, setLoading] = useState(true);
  let toast = useToast();
  const calledRef = useRef(false);
  const navigate = useNavigate();

  const handleJoinOrganization = async () => {
    setLoading(true);
    let formData = await getData('orgData');
    if(formData){
      const parsedData: OrgData = JSON.parse(String(formData));
      let response = await organizationSignUp(parsedData?.name, parsedData?.description, parsedData?.industry, parsedData?.website, parsedData?.email, parsedData?.phone_number, parsedData?.address);
      if(response.success == true){
        storeOrgDataToStorage(response?.data);
        let subscriptionData = await getData('subscriptionPlanInfo');
        const parsedSubData: OrganizationSubscription = JSON.parse(String(subscriptionData));
        let subResponse = await saveOrganizationSubscription(response?.data?.id, parsedSubData?.tier, parsedSubData?.is_trial, parsedSubData?.trial_days);

        if(subResponse?.success===true){


        toast({
          title: 'Success',
          description: 'Organization created successfully!',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });
        await deleteData('orgData');
        alert('Organization created successfully!');
        window.location.href = "/home";
      }else{
        toast({
          title: 'Error',
          description: 'An error occured',
          status: 'warning',
          duration: 4000,
          isClosable: true,
        });
        alert('Organization created successfully!');
        navigate(`/home`);
      }

      }else{
        toast({
          title: 'Error',
          description: `Error on creating organization ${response?.data}`,
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
        console.log('error',response?.data);
      }
      // formData = JSON.parse(formData);
    }
  }

  useEffect(() => {
    if (!calledRef.current) {
      handleJoinOrganization();
      calledRef.current = true;
    }
  }, []);
    
  return (
    <Box maxW="md" mx="auto" mt={10} p={8} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <HStack spacing={5} align="stretch">
        {loading && <Spinner />}
        <Text>Creating Organization</Text>
      </HStack>
    </Box>
  );
}
